import values from 'lodash/values';
import { ProviderInfo } from 'modules/types/ProviderInfo';

interface Provider {
  name: string;
  practiceName: string;
  id: string;
  type: string;
  availability: string;
}

export const normalizeProviders = (providers: Provider[] = []): ProviderInfo[] =>
  values(providers).map(p => ({
    id: p.id,
    name: p.name,
    personnelId: parseInt(p.id, 10), // TODO: do we need this?
    specialties: [{ nameLong: p.practiceName, id: '', nameShort: '' }], // TODO: this should be a standard "specialtiesSet"
    profileImageUrl:
      p.providerProfileImageUrl ||
      'https://intermountainhealthcare.org/-/media/images/modules/physician-directory/profiles/a/abbott-j-thaddaeus.jpg?mh=320&mw=320', // TODO: we need p.providerProfileImageUrl,
    resourceDisplay: p.name // TODO: do we need this?
  }));

export const cheese = true;
